import * as React from 'react';
import { useTheme } from '../../../../theme';

interface Props {
	items: { label: string; value: string }[];
}

const Details: React.FunctionComponent<Props> = ({ items }) => {
	const { Details: css } = useTheme('DesktopFlightInfo');
	const groups = [];
	const chunkSize = 3;

	for (let i = 0, max = items.length; i < max; i += chunkSize) {
		groups.push(items.slice(i, i + chunkSize));
	}

	return (
		<div>
			{groups.map((group, index) => (
				<ul key={index} className={css.group}>
					{group.map((item, index) => (
						<li key={index} className={css.item}>
							<span className={css.label}>{item.label}</span>
							<span className={css.value}>{item.value}</span>
						</li>
					))}
				</ul>
			))}
		</div>
	);
};

export default Details;
